import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DuplicateLeadDownload = ({ isOpen, duplicateLeads, onClose }) => {
  if (!isOpen) return null;

  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(duplicateLeads);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Duplicate Leads");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(data, "Duplicate_Leads.xlsx");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[545px] h-[413px] relative">
        <button
          className="absolute top-5 right-4  text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          ✖
        </button>
        <h2 className="text-[24px] font-semibold text-customGreen mb-3 text-center">
          Duplicate Data
        </h2>
        <p className="text-sm text-center text-gray-600 mb-4">
          In the upload file there are {duplicateLeads?.length} duplicate date
          has been found.
        </p>
        <div
          className="text-blue-500 cursor-pointer underline  text-center"
          onClick={handleDownload}
        >
          Download Duplicate Excel
        </div>

        <div className="overflow-auto custom-scrollbar  max-h-60 mt-5">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-2">S.No</th>
         
                <th className="border p-2">Name</th>
                <th className="border p-2">Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {duplicateLeads.map((lead, index) => (
                <tr key={index}>
                  <td className="border p-2 text-center">{lead.rowNumber}</td>
                  <td className="border p-2">{lead.name}</td>
                  <td className="border p-2">{lead.phoneNumber}</td>
             
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DuplicateLeadDownload;
